// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { FaVideo, FaFilm, FaPalette, FaMagic } from "react-icons/fa";

// // Sample Videos for Preview (replace with actual paths)
// const VIDEOS = {
//   preview1:
//     "https://www.premiumbeat.com/blog/wp-content/uploads/2017/10/Montage2.gif",
//   preview2: "https://www.w3schools.com/html/movie.mp4",
// };

// const TwoDVideoEditing = () => {
//   useEffect(() => {
//     AOS.init({ duration: 800, once: true });
//     window.scrollTo(0, 0);
//   }, []);

//   const features = [
//     {
//       icon: <FaVideo className="text-blue-600 text-3xl" />,
//       title: "Timeline Mastery",
//       desc: "Learn to manage your clips, transitions, and layers efficiently.",
//       video: VIDEOS.preview1,
//     },
//     {
//       icon: <FaFilm className="text-purple-600 text-3xl" />,
//       title: "Transitions & Effects",
//       desc: "Add smooth transitions, visual effects, and motion graphics.",
//       video: VIDEOS.preview2,
//     },
//     {
//       icon: <FaPalette className="text-red-600 text-3xl" />,
//       title: "Color Grading",
//       desc: "Adjust colors, contrast, and mood for cinematic results.",
//     },
//     {
//       icon: <FaMagic className="text-green-600 text-3xl" />,
//       title: "Special Effects",
//       desc: "Create stunning 2D effects like motion blur, keying, and overlays.",
//     },
//   ];

//   const workflow = [
//     "Import your footage and organize the timeline.",
//     "Trim and cut clips for precise editing.",
//     "Add transitions, effects, and overlays.",
//     "Perform color correction and grading.",
//     "Export your final video in multiple formats.",
//   ];

//   return (
//     <div className="bg-white text-black font-sans min-h-screen">
//       {/* Hero */}
//       <section className="relative flex flex-col items-center justify-center text-center py-32 bg-gradient-to-r from-blue-100 via-white to-pink-100">
//         <h1 className="text-5xl sm:text-6xl font-extrabold drop-shadow-md">
//           2D Video Editing Masterclass
//         </h1>
//         <p className="mt-6 max-w-2xl mx-auto text-lg text-gray-700">
//           Learn to create cinematic 2D videos with professional editing, color
//           grading, and effects.
//         </p>
//       </section>

//       {/* Features */}
//       <section className="max-w-6xl mx-auto px-6 py-16">
//         <h2 className="text-3xl font-bold text-center mb-12" data-aos="fade-up">
//           Key Skills You Will Learn
//         </h2>
//         <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
//           {features.map((f, i) => (
//             <div
//               key={i}
//               className="relative group p-6 bg-gray-50 rounded-xl shadow-xl hover:shadow-2xl transition transform hover:-translate-y-2 hover:scale-105"
//               data-aos="zoom-in"
//               data-aos-delay={i * 100}
//             >
//               <div className="mb-4">{f.icon}</div>
//               <h3 className="font-semibold text-lg mb-2">{f.title}</h3>
//               <p className="text-gray-700 text-sm">{f.desc}</p>
//               {f.video && (
//                 <video
//                   src={f.video}
//                   className="absolute top-0 left-0 w-full h-full opacity-0 group-hover:opacity-100 object-cover rounded-xl transition-opacity duration-500"
//                   autoPlay
//                   loop
//                   muted
//                 />
//               )}
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Workflow */}
//       <section className="bg-gray-50 py-16">
//         <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
//           <div data-aos="fade-right">
//             <h3 className="text-2xl font-bold mb-6">Course Workflow</h3>
//             <ol className="space-y-4">
//               {workflow.map((step, i) => (
//                 <li key={i} className="flex gap-4 items-start">
//                   <span className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold">
//                     {i + 1}
//                   </span>
//                   <p className="text-gray-700">{step}</p>
//                 </li>
//               ))}
//             </ol>
//           </div>
//           <div data-aos="fade-left" className="relative">
//             <img
//               src="https://www.premiumbeat.com/blog/wp-content/uploads/2017/10/Montage2.gif"
//               alt="Workflow"
//               className="rounded-xl shadow-lg"
//             />
//           </div>
//         </div>
//       </section>

//       {/* Enroll Section */}
//       <section className="py-16 text-center" data-aos="fade-up">
//         <h3 className="text-3xl font-bold mb-6">
//           Ready to Master 2D Video Editing?
//         </h3>
//         <p className="text-gray-700 mb-8">
//           Join thousands of learners and elevate your video editing skills.
//         </p>
//         <a
//           href="/enroll"
//           className="px-8 py-4 bg-blue-600 text-white font-semibold rounded-full shadow-lg hover:bg-blue-700 transition transform hover:scale-105 animate-pulse inline-block"
//         >
//           Enroll Now
//         </a>
//       </section>
//     </div>
//   );
// };

// export default TwoDVideoEditing;

// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import {
//   FaVideo,
//   FaFilm,
//   FaPalette,
//   FaMagic,
//   FaCertificate,
//   FaUsers,
//   FaClock,
// } from "react-icons/fa";

// // Sample Videos for Preview (replace with actual paths)
// const VIDEOS = {
//   preview1:
//     "https://www.premiumbeat.com/blog/wp-content/uploads/2017/10/Montage2.gif",
//   preview2: "https://www.w3schools.com/html/movie.mp4",
// };

// const TwoDVideoEditing = () => {
//   useEffect(() => {
//     AOS.init({ duration: 800, once: true });
//     window.scrollTo(0, 0);
//   }, []);

//   const features = [
//     {
//       icon: <FaVideo className="text-blue-600 text-3xl" />,
//       title: "Timeline Mastery",
//       desc: "Learn to manage your clips, transitions, and layers efficiently.",
//       video: VIDEOS.preview1,
//     },
//     {
//       icon: <FaFilm className="text-purple-600 text-3xl" />,
//       title: "Transitions & Effects",
//       desc: "Add smooth transitions, visual effects, and motion graphics.",
//       video: VIDEOS.preview2,
//     },
//     {
//       icon: <FaPalette className="text-red-600 text-3xl" />,
//       title: "Color Grading",
//       desc: "Adjust colors, contrast, and mood for cinematic results.",
//     },
//     {
//       icon: <FaMagic className="text-green-600 text-3xl" />,
//       title: "Special Effects",
//       desc: "Create stunning 2D effects like motion blur, keying, and overlays.",
//     },
//   ];

//   const workflow = [
//     "Import your footage and organize the timeline.",
//     "Trim and cut clips for precise editing.",
//     "Add transitions, effects, and overlays.",
//     "Perform color correction and grading.",
//     "Export your final video in multiple formats.",
//   ];

//   const outcomes = [
//     "Master video editing tools like Adobe Premiere Pro, After Effects, or similar software.",
//     "Gain confidence in editing short films, YouTube videos, advertisements, and social media content.",
//     "Understand storytelling and pacing for impactful edits.",
//     "Build a professional portfolio of edited projects.",
//     "Receive a certificate of completion to boost your career profile.",
//   ];

//   return (
//     <div className="bg-white text-black font-sans min-h-screen">
//       {/* Hero with Background GIF */}
//       <section
//         className="relative flex flex-col items-center justify-center text-center h-[85vh] bg-cover bg-center"
//         style={{
//           backgroundImage:
//             "url('https://blogs.nvidia.com/wp-content/uploads/2023/02/Blender_A2F_addon.gif')",
//         }}
//       >
//         <div className="absolute inset-0 bg-black/50"></div>{" "}
//         {/* Overlay for readability */}
//         <div className="relative z-10 px-4">
//           <h1 className="text-5xl sm:text-6xl font-extrabold text-white">
//             2D Video Editing Masterclass
//           </h1>
//           <p className="mt-6 max-w-2xl mx-auto text-lg text-gray-200">
//             Learn to create cinematic 2D videos with professional editing, color
//             grading, and effects.
//           </p>
//         </div>
//       </section>

//       {/* Features */}
//       <section className="max-w-6xl mx-auto px-6 py-16">
//         <h2 className="text-3xl font-bold text-center mb-12" data-aos="fade-up">
//           Key Skills You Will Learn
//         </h2>
//         <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
//           {features.map((f, i) => (
//             <div
//               key={i}
//               className="relative group p-6 bg-gray-50 rounded-xl shadow-xl hover:shadow-2xl transition transform hover:-translate-y-2 hover:scale-105"
//               data-aos="zoom-in"
//               data-aos-delay={i * 100}
//             >
//               <div className="mb-4">{f.icon}</div>
//               <h3 className="font-semibold text-lg mb-2">{f.title}</h3>
//               <p className="text-gray-700 text-sm">{f.desc}</p>
//               {f.video && (
//                 <video
//                   src={f.video}
//                   className="absolute top-0 left-0 w-full h-full opacity-0 group-hover:opacity-100 object-cover rounded-xl transition-opacity duration-500"
//                   autoPlay
//                   loop
//                   muted
//                 />
//               )}
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Workflow */}
//       <section className="bg-gray-50 py-16">
//         <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
//           <div data-aos="fade-right">
//             <h3 className="text-2xl font-bold mb-6">Course Workflow</h3>
//             <ol className="space-y-4">
//               {workflow.map((step, i) => (
//                 <li key={i} className="flex gap-4 items-start">
//                   <span className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold">
//                     {i + 1}
//                   </span>
//                   <p className="text-gray-700">{step}</p>
//                 </li>
//               ))}
//             </ol>
//           </div>
//           <div data-aos="fade-left" className="relative">
//             <img
//               src="https://www.premiumbeat.com/blog/wp-content/uploads/2017/10/Montage2.gif"
//               alt="Workflow"
//               className="rounded-xl shadow-lg"
//             />
//           </div>
//         </div>
//       </section>

//       {/* What You’ll Gain */}
//       <section className="py-16 max-w-6xl mx-auto px-6">
//         <h3 className="text-3xl font-bold text-center mb-12" data-aos="fade-up">
//           What You’ll Gain From This Course
//         </h3>
//         <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
//           {outcomes.map((item, i) => (
//             <div
//               key={i}
//               className="p-6 bg-white border rounded-xl shadow-md hover:shadow-lg transition"
//               data-aos="fade-up"
//               data-aos-delay={i * 100}
//             >
//               <p className="text-gray-700">{item}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Extra Info */}
//       <section className="bg-blue-50 py-16 text-center">
//         <div className="max-w-4xl mx-auto">
//           <h3 className="text-3xl font-bold mb-6">Who Is This Course For?</h3>
//           <p className="text-lg text-gray-700 mb-6">
//             Whether you’re a beginner looking to start your editing journey, a
//             YouTuber wanting professional-looking videos, or a filmmaker
//             exploring storytelling – this course is designed to help you.
//           </p>
//           <div className="flex flex-wrap justify-center gap-6">
//             <div className="flex items-center gap-2">
//               <FaUsers className="text-blue-600" /> Beginners & Creators
//             </div>
//             <div className="flex items-center gap-2">
//               <FaClock className="text-green-600" /> Flexible Learning
//             </div>
//             <div className="flex items-center gap-2">
//               <FaCertificate className="text-purple-600" /> Certificate of
//               Completion
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Enroll Section */}
//       <section className="py-16 text-center" data-aos="fade-up">
//         <h3 className="text-3xl font-bold mb-6">
//           Ready to Master 2D Video Editing?
//         </h3>
//         <p className="text-gray-700 mb-8">
//           Join thousands of learners and elevate your video editing skills.
//         </p>
//         <a
//           href="/enroll"
//           className="px-8 py-4 bg-blue-600 text-white font-semibold rounded-full shadow-lg hover:bg-blue-700 transition transform hover:scale-105 animate-pulse inline-block"
//         >
//           Enroll Now
//         </a>
//       </section>
//     </div>
//   );
// };

// export default TwoDVideoEditing;

import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaVideo,
  FaFilm,
  FaPalette,
  FaMagic,
  FaCertificate,
  FaUsers,
  FaClock,
} from "react-icons/fa";
import { Link } from "react-router-dom";

// Sample Videos for Preview (replace with actual paths)
const VIDEOS = {
  preview1:
    "https://www.premiumbeat.com/blog/wp-content/uploads/2017/10/Montage2.gif",
  preview2: "https://www.w3schools.com/html/movie.mp4",
};

const TwoDVideoEditing = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
    window.scrollTo(0, 0);
  }, []);

  const features = [
    {
      icon: <FaVideo className="text-blue-600 text-4xl" />,
      title: "Timeline Mastery",
      desc: "Learn to manage your clips, transitions, and layers efficiently.",
      video: VIDEOS.preview1,
      anim: "animate-bounce",
    },
    {
      icon: <FaFilm className="text-purple-600 text-4xl" />,
      title: "Transitions & Effects",
      desc: "Add smooth transitions, visual effects, and motion graphics.",
      video: VIDEOS.preview2,
      anim: "animate-pulse",
    },
    {
      icon: <FaPalette className="text-red-600 text-4xl" />,
      title: "Color Grading",
      desc: "Adjust colors, contrast, and mood for cinematic results.",
      anim: "animate-spin-slow",
    },
    {
      icon: <FaMagic className="text-green-600 text-4xl" />,
      title: "Special Effects",
      desc: "Create stunning 2D effects like motion blur, keying, and overlays.",
      anim: "animate-jump",
    },
  ];

  const workflow = [
    "Import your footage and organize the timeline.",
    "Trim and cut clips for precise editing.",
    "Add transitions, effects, and overlays.",
    "Perform color correction and grading.",
    "Export your final video in multiple formats.",
  ];

  const outcomes = [
    "Master video editing tools like Adobe Premiere Pro, After Effects, or similar software.",
    "Gain confidence in editing short films, YouTube videos, advertisements, and social media content.",
    "Understand storytelling and pacing for impactful edits.",
    "Build a professional portfolio of edited projects.",
    "Receive a certificate of completion to boost your career profile.",
  ];

  const outcomeColors = [
    "bg-blue-100",
    "bg-green-100",
    "bg-yellow-100",
    "bg-pink-100",
    "bg-purple-100",
  ];

  return (
    <div className="bg-white text-black min-h-screen overflow-hidden">
      {/* Hero with Background GIF */}
      <section
        className="relative flex flex-col items-center justify-center text-center h-[85vh] bg-cover bg-center"
        style={{
          backgroundImage:
            "url('/assets/Blender_A2F_addon.gif')",
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        {/* Overlay for readability */}
        <div className="relative z-10 px-4">
          <h1 className="text-5xl sm:text-6xl font-extrabold text-white">
            2D Video Editing Masterclass
          </h1>
          <p className="mt-6 max-w-2xl mx-auto text-lg text-gray-200">
            Learn to create cinematic 2D videos with professional editing, color
            grading, and effects.
          </p>

          {/* Enroll Button */}
          <div className="mt-8">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-full bg-purple-600 px-6 py-3 text-white font-semibold shadow-lg hover:bg-purple-700 transition"
            >
              Enroll Now
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="max-w-6xl mx-auto px-6 py-16">
        <h2 className="text-3xl font-bold text-center mb-12" data-aos="fade-up">
          Key Skills You Will Learn
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((f, i) => {
            const bgColors = ["#E0F7FA", "#FCE4EC", "#FFF3E0", "#E8F5E9"]; // mild pastel backgrounds
            return (
              <div
                key={i}
                className="relative group p-6 rounded-xl shadow-xl hover:shadow-2xl transition transform hover:-translate-y-2 hover:scale-105"
                data-aos="zoom-in"
                data-aos-delay={i * 100}
                style={{ backgroundColor: bgColors[i % bgColors.length] }}
              >
                <div className={`mb-4 flex justify-center ${f.anim}`}>
                  {f.icon}
                </div>
                <h3 className="font-semibold text-lg mb-2 text-center">
                  {f.title}
                </h3>
                <p className="text-gray-700 text-sm text-center">{f.desc}</p>
                {f.video && (
                  <video
                    src={f.video}
                    className="absolute top-0 left-0 w-full h-full opacity-0 group-hover:opacity-100 object-cover rounded-xl transition-opacity duration-500"
                    autoPlay
                    loop
                    muted
                  />
                )}
              </div>
            );
          })}
        </div>
      </section>

      {/* Workflow */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          <div data-aos="fade-right">
            <h3 className="text-2xl font-bold mb-6">Course Workflow</h3>
            <ol className="space-y-4">
              {workflow.map((step, i) => (
                <li
                  key={i}
                  className="flex gap-4 items-start bg-blue-50 rounded-lg p-4"
                >
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold">
                    {i + 1}
                  </span>
                  <p className="text-gray-700">{step}</p>
                </li>
              ))}
            </ol>
          </div>
          <div data-aos="fade-left" className="relative">
            <img
              src="/assets/Montage2.webp"
              alt="Workflow"
              className="rounded-xl shadow-lg"
            />
          </div>
        </div>
      </section>

      {/* What You’ll Gain */}
      <section className="py-16 max-w-6xl mx-auto px-6">
        <h3 className="text-3xl font-bold text-center mb-12" data-aos="fade-up">
          What You’ll Gain From This Course
        </h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {outcomes.map((item, i) => {
            const cornerColors = [
              "#ff9800",
              "#4caf50",
              "#2196f3",
              "#e91e63",
              "#9c27b0",
              "#00bcd4",
            ];
            const bgColors = [
              "#FFF3E0", // mild orange
              "#E8F5E9", // mild green
              "#E0F7FA", // mild blue
              "#FCE4EC", // mild pink
              "#EDE7F6", // mild purple
              "#E0F2F1", // mild teal
            ];
            const cornerColor = cornerColors[i % cornerColors.length];
            const bgColor = bgColors[i % bgColors.length];

            return (
              <div
                key={i}
                className="relative p-6 border rounded-xl shadow-md hover:shadow-lg transition transform hover:scale-105 shake-card"
                data-aos="fade-up"
                data-aos-delay={i * 100}
                style={{
                  "--corner-color": cornerColor,
                  backgroundColor: bgColor,
                }}
              >
                {/* gradient corner top-left */}
                <div
                  className="corner-accent"
                  style={{
                    top: 0,
                    left: 0,
                    bottom: "auto",
                    borderBottomLeftRadius: 0,
                    borderTopLeftRadius: "12px",
                    background: `linear-gradient(135deg, ${cornerColor}, transparent)`,
                    boxShadow: `0 0 8px ${cornerColor}`,
                  }}
                ></div>

                {/* Add padding so text does not overlap the corner */}
                <div className="pt-4 pl-4">
                  <p className="text-gray-800 font-medium text-center">
                    {item}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Extra Info */}
      <section className="bg-blue-50 py-16 text-center">
        <div className="max-w-4xl mx-auto">
          <h3 className="text-3xl font-bold mb-6">Who Is This Course For?</h3>
          <p className="text-lg text-gray-700 mb-6">
            Whether you’re a beginner looking to start your editing journey, a
            YouTuber wanting professional-looking videos, or a filmmaker
            exploring storytelling – this course is designed to help you.
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            <div className="flex items-center gap-2">
              <FaUsers className="text-blue-600" /> Beginners & Creators
            </div>
            <div className="flex items-center gap-2">
              <FaClock className="text-green-600" /> Flexible Learning
            </div>
            <div className="flex items-center gap-2">
              <FaCertificate className="text-purple-600" /> Certificate of
              Completion
            </div>
          </div>
        </div>
      </section>

      {/* Enroll Section */}
      <section className="py-16 text-center" data-aos="fade-up">
        <h3 className="text-3xl font-bold mb-6">
          Ready to Master s2D Video Editing?
        </h3>
        <p className="text-gray-700 mb-8">
          Join thousands of learners and elevate your video editing skills.
        </p>
        <Link
          to="/contact"
          className="px-8 py-4 bg-blue-600 text-white font-semibold rounded-full shadow-lg hover:bg-blue-700 transition transform hover:scale-105 animate-pulse inline-block"
        >
          Enroll Now
        </Link>
      </section>

      {/* Animations CSS */}
      <style>{`

      @keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-5px);
  }
  40% {
    transform: translateX(5px);
  }
  60% {
    transform: translateX(-5px);
  }
  80% {
    transform: translateX(5px);
  }
}

.shake-card {
  animation: shake 3s infinite ease-in-out;
  position: relative; /* required for corner */
  overflow: hidden;
}

.corner-accent {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, var(--corner-color), transparent);
  border-bottom-left-radius: 12px;
  box-shadow: 0 0 8px var(--corner-color);
}

        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20%, 60% { transform: translateX(-5px); }
          40%, 80% { transform: translateX(5px); }
        }

        @keyframes jump {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-12px); }
        }

        .animate-shake {
          animation: shake 0.6s infinite;
        }

        .animate-jump {
          animation: jump 0.8s infinite;
        }

        .animate-spin-slow {
          animation: spin 3s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default TwoDVideoEditing;
